import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Mail, ArrowLeft, CheckCircle2 } from "lucide-react";
import { Logo } from "../components/Logo";
import { api, apiError } from "../lib/api";
import { Button } from "../components/ui/button";

export default function ForgotPassword() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) { setError(apiError(err)); } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <div className="text-center mb-6"><Logo className="justify-center" /></div>
      <div className="bg-white rounded-3xl shadow-warm-lg p-7">
        {sent ? (
          <div className="text-center" data-testid="forgot-sent">
            <CheckCircle2 size={56} className="text-fresh-mint mx-auto" />
            <h1 className="font-display font-extrabold text-xl text-urban-teal mt-4">Vérifiez votre boîte mail</h1>
            <p className="text-urban-teal/60 mt-2 text-sm">Si un compte existe pour <span className="font-semibold">{email}</span>, vous recevrez un lien pour réinitialiser votre mot de passe. Il est valable 1 heure.</p>
            <Button onClick={() => nav("/connexion")} className="rounded-full bg-urban-teal text-white font-bold mt-6" data-testid="back-to-login">Retour à la connexion</Button>
          </div>
        ) : (
          <>
            <h1 className="font-display font-extrabold text-2xl text-urban-teal">Mot de passe oublié ?</h1>
            <p className="text-urban-teal/60 mt-1 text-sm">Entrez votre email, on vous envoie un lien de réinitialisation.</p>
            <form onSubmit={submit} className="space-y-4 mt-5">
              <div>
                <label className="text-xs font-bold uppercase text-urban-teal/50">Email</label>
                <div className="flex items-center gap-2 border-2 border-cream-bg focus-within:border-urban-teal rounded-xl px-3 py-2.5 mt-1 transition-colors">
                  <Mail size={18} className="text-street-gold shrink-0" />
                  <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="vous@foodtruck.fr" className="w-full outline-none bg-transparent text-urban-teal" data-testid="forgot-email" />
                </div>
              </div>
              {error && <p className="text-sm text-coral-twist" data-testid="forgot-error">{error}</p>}
              <Button type="submit" disabled={busy} className="w-full rounded-full h-12 font-bold text-white bg-street-gold hover:bg-street-gold/90" data-testid="forgot-submit">{busy ? "Envoi..." : "Envoyer le lien"}</Button>
            </form>
            <button onClick={() => nav("/connexion")} className="text-sm text-urban-teal/60 font-semibold flex items-center gap-1 mt-4 mx-auto hover:text-street-gold" data-testid="forgot-back"><ArrowLeft size={14} /> Retour à la connexion</button>
          </>
        )}
      </div>
    </div>
  );
}
